import './style.scss';
import BackButtonIcon from '../../Images/PricingImages/BackButtonIcon.svg';
import RightTick from '../../Images/PricingImages/RightTick.svg';
import PricingStar from '../../Images/PricingImages/PricingStar.svg';
import { Input, Spin, message } from 'antd';
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import trueIcon from '../../Images/PricingImages/true.svg';
import { useEffect, useState } from 'react';
import axios from 'axios';
// import DynamicModal from '../DynamicModal/DynamicModal';
// import EnterpriseModal from './EnterpriseModal';
import { LoadingOutlined } from '@ant-design/icons';
import bottomChevron from '../../Images/PricingImages/chevron_bottom.svg';
import { projects } from '../../config';

const baseUrl = 'https://api-nimbus.flixstock.com/';
const distributorId = '663b39b3ab4ec46c6ebcf259';
const token = localStorage.getItem('metamodel_token');



const PricingPage = ({
  userEmail,
  isAuthenticated,
  isLoginPopUp,
  dispatcher,
  isLoggedInByPricing,
  from,
}) => {



  
  const [searchParams, setSearchParams] = useSearchParams({});
  const [pricingList, setPricingList] = useState([]);
  const [email, setEmail] = useState('');
  const [comparisonData, setComparisonData] = useState({});
  const [selectedValue, setSelectedValue] = useState('500');
  const [subscribeValue, setSubscribeValue] = useState('10');
  const [oldValues, setOldValues] = useState('15');
  const [selectedID, setSelectedID] = useState('664f1a93877667b7bee50022');
  const [selectedRateCode, setSelectedRateCode] = useState(
    '00af7cf7-5c9b-4ad1-8fda-567f9b2caced'
  );
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [enterpriseBtnClicked, setEnterpriseBtnClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [redirectby, setRedirectby] = useState('');
  const [isToggledFree, setIsToggledFree] = useState(false);
  const [isToggledBasic, setIsToggledBasic] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [currencyValue, setCurrencyValue] = useState('');
  const [tempPriceData, setTempPriceData] = useState();
  const navigate = useNavigate();



  
  const getPricingData = async () => {
    setLoading(true);
    try {
      const getResponse = await axios.get(`${baseUrl}api/v1/pricing/`,{
       
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            distributorId,
          },
        
      });
      const result = (await getResponse?.data?.pricingInfo) || [];
      if (result.length > 0) {
        const sortedResult = result.sort((a, b) => {
          if (a.name === 'Free') return -1;
          if (b.name === 'Free') return 1;
          if (a.name === 'Basic') return -1;
          if (b.name === 'Basic') return 1;
          return 0; 
        });
      
        setPricingList(sortedResult);
      }
      
      setLoading(false);
      pricingList?.forEach((res) => {
        if (res?.name === 'Business Plan') {
          debugger;
          setOldValues(res?.rateInfo[0]?.oldValue);
          setSubscribeValue(res?.rateInfo[0]?.value);
        }
      });
      setCurrencyValue(pricingList[0]?.currency);
    } catch (error) {
      console.error('Error:', error);
    }
  };

 
  const handlePrice = (rate, piid, rcid, plan, currency, credits) => {
    if (from == 'static_metamodels') {
      window.open('https://app.metamodels.ai/login', '_blank');

      return;
    }
    if (!userEmail && !isAuthenticated) {
      dispatcher({
        type: 'LOGINPOPUP',
        payload: true,
      });
      let tempData = {
        rate: rate,
        piid: piid,
        rcid: rcid,
        plan: plan,
        currency: currency,
        credits: credits,
      };
      setTempPriceData(tempData);
      return;
    }
    dispatcher({
      type: 'LOGINPOPUP',
      payload: false,
      isLogeedInPayload: false,
    });
    navigate(
      `/plan-details?rate=${rate}&piid=${piid}&rcid=${rcid}&plan=${plan}&currency=${currency}&credits=${credits}${
        redirectby ? '&redirectby=' + redirectby : ''
      }`
    );
  };

  useEffect(() => {
    if (isLoggedInByPricing && tempPriceData) {
      const { rate, piid, rcid, plan, currency, credits } = tempPriceData;
      handlePrice(rate, piid, rcid, plan, currency, credits);
    }
  }, [isLoggedInByPricing, tempPriceData]);

  useEffect(() => {
    if (searchParams.get('redirectby')) {
      setRedirectby(searchParams.get('redirectby'));
    }
  }, [searchParams.get('redirectby')]);

  const handleToggle = (index) => {
    if (index === 0) {
      setIsToggledFree(!isToggledFree);
      setSelectedIndex(index);
    } else {
      setIsToggledBasic(!isToggledBasic);
      setSelectedIndex(index);
    }
  };

  const handleEnterpriseToggle = () => {
    setIsToggled(!isToggled);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {}, [selectedIndex]);

  const handleChange = (event, value, id, old, rateCode) => {
    setSelectedValue(event.target.value);
    setSubscribeValue(value);
    setOldValues(old);
    setSelectedRateCode(rateCode);
  };
  function createComparisonStructure(pricingList) {
    const result = {};
    pricingList?.forEach((plan) => {
      plan?.comparisonList?.forEach((comparison) => {
        const { groupName, key, value } = comparison;
        if (!result[groupName]) {
          result[groupName] = {};
        }
        if (!result[groupName][key]) {
          result[groupName][key] = {};
        }
        result[groupName][key][plan.name.toLowerCase().replace(' ', '_')] =
          value;
      });
    });
    setComparisonData(result);
  }

  useEffect(() => {
    getPricingData();
  }, []);

  const getCurrency = () => {
    return currencyValue === 'INR' ? '₹' : '$';
  };

  useEffect(() => {}, [currencyValue]);

  useEffect(() => {
    createComparisonStructure(pricingList);
  }, [pricingList, selectedValue, subscribeValue, oldValues, selectedRateCode]);

  const enterpriseData = {
    id: 4,
    name: 'Custom',
    description: 'High-Volume Solutions',
    features: [
      'Unlimited Photo Credit',
      'Unlimited Model Access',
      'On demand new models',
      'Fastest Processing Time',
      'Manual Photo Revisions',
    ],
  };

  const handleModalPopup = () => {
    setEnterpriseBtnClicked(true);
    setOpenModal(true);
  };
  // const getEnterpriseModal = () => {
  //   return (
  //     <DynamicModal
  //       open={openModal}
  //       closable={true}
  //       close={() => {
  //         setOpenModal(false);
  //       }}
  //       footer={null}
  //       width={'100%'}
  //       height={'100%'}
  //       classWrapper="enterprise_popup"
  //       component={
  //         <EnterpriseModal
  //           openModal={openModal}
  //           setOpenModal={setOpenModal}
  //           setEnterpriseBtnClicked={setEnterpriseBtnClicked}
  //           enterpriseBtnClicked={enterpriseBtnClicked}
  //         />
  //       }
  //     />
  //   );
  // };

  const getBackButton = () => {
    return (
      <div className="back_button">
        <Link to={'/'}>
          {' '}
          <img src={BackButtonIcon} alt="backButton" />
        </Link>
      </div>
    );
  };

  const getHeading = () => {
    return (
      <div className="heading">
        <h2>Choose the perfect plan for your business needs</h2>
      </div>
    );
  };

  const getPricingList = () => {
    return pricingList?.map((pricing, index) => {
      const { _id, name, description, featureList, currency, rateInfo } =
        pricing || {};
      const hasRateInfo = rateInfo && rateInfo.length > 0;
      return name !== 'Business Plan' ? (
        <div className="card_wrapper">
          <div className="card_content">
            <div className="heading">
              <div className="main_title">{name}</div>
              <div className="sub_title">{description}</div>
              <div className="price">
                {name === 'Free' && hasRateInfo && (
                  <div className="new_price">
                    {getCurrency()}
                    {rateInfo[0]?.value}
                    {/* <span> /month</span> */}
                  </div>
                )}
                {name !== 'Free' && hasRateInfo && rateInfo[0]?.oldValue && (
                  <div className="old_price">
                    <s>
                      {getCurrency()}
                      {rateInfo[0]?.oldValue}
                    </s>
                  </div>
                )}
                {name !== 'Free' && hasRateInfo && rateInfo[0]?.value && (
                  <div className="new_price">
                    {getCurrency()}
                    {rateInfo[0]?.value}
                    {/* <span> /month</span> */}
                  </div>
                )}
              </div>
              <div className="button_wrapper">
                {name === 'Free' ? (
                  <button className="button_one disabled">
                    Already Selected
                  </button>
                ) : (
                  <button
                    className={`${
                      name === 'Enterprise' ? 'button_two' : 'button_one'
                    }`}
                    onClick={() =>
                      handlePrice(
                        rateInfo[0]?.value,
                        _id,
                        rateInfo[0]?.rateCode,
                        name,
                        getCurrency(),
                        rateInfo[0]?.config?.credits
                      )
                    }
                  >
                    Buy Now
                  </button>
                )}
              </div>
              <div className="card_details_wrapper">
                <div className="details_title">
                  What you get:{' '}
                  {isMobile ? (
                    <img
                      src={bottomChevron}
                      onClick={() => handleToggle(index)}
                      alt=""
                      className={`chevron ${
                        index === 0
                          ? isToggledFree && 'show'
                          : '' || index === 1
                          ? isToggledBasic && 'show'
                          : ''
                      }`}
                    />
                  ) : (
                    ''
                  )}
                </div>
                <div
                  className={`details_description ${
                    index === 0
                      ? isToggledFree && 'show'
                      : '' || index === 1
                      ? isToggledBasic && 'showBasic'
                      : ''
                  }`}
                >
                  {featureList?.map((details, id) => {
                    return (
                      <div className="card_details_content">
                        <img src={RightTick} alt="tick" />
                        {details}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="popular_card_wrapper">
          <div className="card_header">
            Most Popular (40% Discount)
            <img src={PricingStar} alt="star" />
          </div>
          <div className="card_content">
            <div className="heading">
              <div className="main_title">{name}</div>
              <div className="sub_title">{description}</div>
              <div className="price">
                {hasRateInfo && rateInfo[0]?.oldValue && (
                  <div className="old_price">
                    <s>
                      {getCurrency()}
                      {oldValues}
                    </s>
                  </div>
                )}
                {hasRateInfo && rateInfo[0]?.value && (
                  <div className="new_price">
                    {getCurrency()}
                    {subscribeValue}
                    {/* <span> /month</span> */}
                  </div>
                )}
              </div>
            </div>
            <div className="break" />
            <div className="card_details_wrapper">
              <div className="details_title">Pay Monthly</div>
              <div className="details_description">
                {hasRateInfo &&
                  rateInfo?.map((details, index) => {
                    const { config, value, _id, oldValue, rateCode } = details;

                    return (
                      <div className="card_details_content">
                        <div className="card_details_content_left">
                          <label className="custom-radio" key={index}>
                            <input
                              type="radio"
                              id={`option-${index}`}
                              name="option"
                              value={config?.credits}
                              defaultChecked={index === 0}
                              onChange={(event) =>
                                handleChange(
                                  event,
                                  value,
                                  _id,
                                  oldValue,
                                  rateCode
                                )
                              }
                            />
                            <span class="radio-btn"></span>
                            {config?.credits} credits
                          </label>
                        </div>
                        <div className="card_details_content_right">
                          {getCurrency()}
                          {value}
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="button_wrapper">
                <button
                  className="button_one"
                  onClick={() =>
                    handlePrice(
                      subscribeValue,
                      _id,
                      selectedRateCode,
                      name,
                      getCurrency(),
                      selectedValue
                    )
                  }
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  // const getEnterpriseData = () => {
  //   return (
  //     <div className="card_content">
  //       <div className="heading">
  //         <div className="main_title">{enterpriseData?.name}</div>
  //         <div className="sub_title">{enterpriseData?.description}</div>
  //         <div className="button_wrapper no_margin">
  //           <button
  //             onClick={handleModalPopup}
  //             className={`${
  //               name === 'Enterprise' ? 'button_two' : 'button_one'
  //             }`}
  //           >
  //             Get Started
  //           </button>
  //           {openModal && getEnterpriseModal()}
  //         </div>
  //         <div className="card_details_wrapper">
  //           <div className="details_title">
  //             What you get:
  //             {isMobile ? (
  //               <img
  //                 src={bottomChevron}
  //                 onClick={() => handleEnterpriseToggle()}
  //                 alt=""
  //                 className={`chevron ${isToggled ? 'show' : ''}`}
  //               />
  //             ) : (
  //               ''
  //             )}
  //           </div>
  //           <div className={`details_description ${isToggled && 'show'}`}>
  //             {enterpriseData?.features?.map((details, id) => {
  //               return (
  //                 <div className="card_details_content">
  //                   <img src={RightTick} alt="tick" />
  //                   {details}
  //                 </div>
  //               );
  //             })}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // const getTableData = () => {
  //   return (
  //     <table>
  //       {Object.keys(comparisonData).map((groupName) => {
  //         return (
  //           <>
  //             <thead>
  //               <tr>
  //                 <th>{groupName}</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {Object.keys(comparisonData[groupName]).map((key) => {
  //                 return (
  //                   <tr className="single_task">
  //                     <td>{key}</td>
  //                     <td>
  //                       {key !== 'Gantt Charts' ? (
  //                         <img src={trueIcon} alt="" />
  //                       ) : (
  //                         comparisonData[groupName][key].free || ''
  //                       )}
  //                     </td>
  //                     <td>
  //                       {key !== 'Customizable Workflows' &&
  //                       key !== 'Gantt Charts' ? (
  //                         <img src={trueIcon} alt="" />
  //                       ) : (
  //                         comparisonData[groupName][key].basic_plan || ''
  //                       )}
  //                     </td>
  //                     <td>
  //                       {key !== 'Customizable Workflows' &&
  //                       key !== 'Gantt Charts' ? (
  //                         <img src={trueIcon} alt="" />
  //                       ) : (
  //                         comparisonData[groupName][key].subscription_plan || ''
  //                       )}
  //                     </td>
  //                     <td>
  //                       {key === 'Customizable Workflows' ? (
  //                         <span>Unlimited</span>
  //                       ) : (
  //                         <img src={trueIcon} alt="" />
  //                       )}
  //                     </td>
  //                   </tr>
  //                 );
  //               })}
  //             </tbody>
  //           </>
  //         );
  //       })}
  //     </table>
  //   );
  // };

  const getCompareData = () => {
    return (
      <div className="card_container">
        <div className="compare_card">
          <div className="compare_card_container">
            <div className="compare_card_wrapper"></div>
            {pricingList?.map((compare, index) => {
              const { name, rateInfo, currency, _id } = compare;
              return (
                <div className="compare_card_wrapper">
                  <div className="compare_card_content">
                    {name === 'Business Plan' ? (
                      <div className="card_title subscription_text">{name}</div>
                    ) : (
                      <div className="card_title">{name}</div>
                    )}
                    <div className="card_price">
                      {getCurrency()}
                      {name === 'Business Plan'
                        ? subscribeValue
                        : rateInfo[0]?.value}
                      <span>/month</span>
                    </div>
                    <div className="compare_button_wrapper">
                      {name === 'Free' ? (
                        <button className="button_one disabled">
                          Already Selected
                        </button>
                      ) : (
                        <button
                          className={`${
                            compare.id == 4 ? 'button_two' : 'button_one'
                          }`}
                          onClick={() =>
                            handlePrice(
                              name === 'Subscription Plan'
                                ? subscribeValue
                                : rateInfo[0]?.value,
                              name === 'Subscription Plan' ? selectedID : _id,
                              name === 'Subscription Plan'
                                ? selectedRateCode
                                : rateInfo[0]?.rateCode,
                              name,
                              getCurrency(),
                              name === 'Subscription Plan'
                                ? selectedValue
                                : rateInfo[0]?.config?.credits
                            )
                          }
                        >
                          Buy Now
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="compare_card_wrapper">
              <div className="compare_card_content">
                <div className="card_title">{enterpriseData.name}</div>
                <div className="card_type">Custom</div>
                <div className="compare_button_wrapper">
                  <button
                    onClick={handleModalPopup}
                    className={`${
                      enterpriseData.id == 4 ? 'button_two' : 'button_one'
                    }`}
                  >
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="compare_table_container">{getTableData()}</div> */}
      </div>
    );
  };
  return (
    <div className="pricing_page_wrapper">
      {loading ? (
        <div className="spinner">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 24,
                  color: '#ff6666',
                  marginLeft: '20px',
                }}
                spin
              />
            }
          />
        </div>
      ) : (
        <div className="pricing_page_container">
          <div className="pricing_content">
            <div className="top_section">
              {getBackButton()}
              {getHeading()}
            </div>
            <div className="price_section">
              {getPricingList()}
              {/* <div className="card_wrapper">{getEnterpriseData()}</div> */}
            </div>
          </div>

          {false && (
            <div className="compare_section">
              <div className="compare_heading">
                <h2>Compare All Features</h2>
              </div>
              {/* {getCompareData()} */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default PricingPage;
